module.exports = __webpack_public_path__ + "static/media/HCMM356.bc54b2c9.jpg";